import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import styles from './InterviewComplete.scss';
import * as actions from '../../store/actions';

import success_top from '../../assets/images/testcomplete/success-top.png';
import success_bot_r from '../../assets/images/testcomplete/success-bot-r.png';
import success_bot_l from '../../assets/images/testcomplete/success-bot-l.png';

class InterviewComplete extends Component {
  componentDidMount() {
    this.props.logout();
  }

  render() {
    const { t, user_detail } = this.props;

    const user =
      user_detail?.user?.name ||
      localStorage.getItem('interviewer_name') ||
      t('interview.default_interviewer');

    return (
      <div className={styles['c-msg-box']}>
        <div className={styles['c-msg-box__top-image']}>
          <img
            src={success_top}
            alt="success-top"
          />
        </div>

        <h2 className="sub-header-font-size-mid bold">
          {t('interview.interview_ended_by', { user })}
        </h2>

        <p className={styles['c-msg-box__instruction']}>{t('interview.thank_you_message')}</p>

        <div className={styles['c-msg-box__bottom-image']}>
          <img
            className={styles['c-msg-box__bottom-image-left']}
            src={success_bot_l}
            alt="success-bot-l"
          />
          <img
            className={styles['c-msg-box__bottom-image-right']}
            src={success_bot_r}
            alt="success-bot-r"
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(actions.logout()),
});

const mapStateToProps = state => ({
  user_detail: state.events.end_interview_user_detail,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(InterviewComplete));
